module.exports = __webpack_public_path__ + "static/media/fvs_valve1_82.8fd52796.jpg";